export const getSessionItem = key => {
  const storedItem = sessionStorage.getItem(key);
  if (typeof storedItem === 'string') {
    return JSON.parse(storedItem);
  }
  return storedItem;
};
export const setSessionItem = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};
export const removeSessionItem = key => {
  sessionStorage.removeItem(key);
};